import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './plugins/router'
import i18n from '@/plugins/locales/i18n'
import {loadConfig} from '@/dataLayer/repository/GlobalSettingManager'
import IKUtils from 'innerken-js-utils'
import store from './plugins/store'
import {FireBaseAuth} from "@/plugins/firebase";
import {forceGetSystemSetting, getRestaurantInfo} from "@/dataLayer/service/api";
import {createPinia, PiniaVuePlugin} from "pinia";
import {useUserStore} from "@/dataLayer/userStore";

Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
Vue.filter('priceDisplay',
  function (price) {
    const res = parseFloat(price).toFixed(2)
    if (store.state.currencySymbols === '$') {
      return store.state.currencySymbols + ' ' + res.replace(',', '.')
    } else {
      return res.replace('.', ',') + ' ' + store.state.currencySymbols
    }
  }
)

const deviceId = IKUtils.getQueryString("deviceId") || IKUtils.getQueryString("DeviceId")

// const tableName = IKUtils.getQueryString("TableName")


async function init() {
  if (deviceId !== null) {
    await localStorage.setItem('deviceId', deviceId)
  }
  await loadConfig()
  const symbol = await forceGetSystemSetting({
    section: 'currencySymbols',
    sKey: 'useCurrencySymbols',
    sValue: '€',
    defaultValue: '€',
    sType: 'string',
    minimumVersion: '1.7.784',
    sOptions: '',
    tagList: 'basic'
  })
  const needAcceptAllOrder = await forceGetSystemSetting({
    section: 'qrApp',
    sKey: 'needAcceptAllOrder',
    sValue: '0',
    defaultValue: '0',
    sType: 'boolean',
    minimumVersion: '1.7.784',
    sOptions: '',
    tagList: 'basic,qrApp'
  })
  const cantOrderDishes = await forceGetSystemSetting({
    section: 'qrApp',
    sKey: 'cantOrderDishes',
    sValue: '0',
    defaultValue: '0',
    sType: 'boolean',
    minimumVersion: '1.7.784',
    sOptions: '',
    tagList: 'basic,qrApp'
  })
  const fastFoodModeOpen = await forceGetSystemSetting({
    section: 'qrApp',
    sKey: 'fastFoodModeOpen',
    sValue: '0',
    defaultValue: '0',
    sType: 'boolean',
    minimumVersion: '1.7.784',
    sOptions: '',
    tagList: 'basic,qrApp'
  })
  store.commit('currencySymbols', symbol)
  store.commit('needAcceptAllOrder', needAcceptAllOrder)
  store.commit('cantOrderDishes', cantOrderDishes)
  store.commit('fastFoodModeOpen', fastFoodModeOpen)
  const restaurantInfo = (await getRestaurantInfo())
  const dailySerialNumberFrom = restaurantInfo?.dailySerialDisplayRotationFrom ? restaurantInfo?.dailySerialDisplayRotationFrom : '0'
  const dailySerialNumberTo = restaurantInfo?.dailySerialDisplayRotationTo
  store.commit('dailySerialNumberFrom', parseFloat(dailySerialNumberFrom))
  store.commit('dailySerialNumberTo', parseFloat(dailySerialNumberTo))
  new Vue({
    vuetify,
    router,
    i18n,
    store,
    pinia,
    render: h => h(App)
  }).$mount('#app')

  // Check for existing PayPal order information
  let paypalOrderInfo = null;
  try {
    paypalOrderInfo = JSON.parse(localStorage.getItem("paypalOrderInfo") || "null");
  } catch (e) {
    console.error("Error parsing paypalOrderInfo from localStorage:", e);
  }
  if (paypalOrderInfo) {
    const orderTimestamp = paypalOrderInfo.timestamp;
    const currentTime = Date.now();
    const twoHoursInMs = 2 * 60 * 60 * 1000;

    // If order is less than 2 hours old, redirect to order number page
    if (currentTime - orderTimestamp < twoHoursInMs) {
      router.push('/order-number');
    }
  }


  FireBaseAuth.onAuthStateChanged(user => {
    console.log(user)
    const userStore = useUserStore()
    userStore.changeCurrentUser(user)
    if (user?.uid) {
      store.commit('changeLogIn', true)
      store.commit('changeUserInfo', user)
      store.commit('showLoginPage', false)
    } else {
      store.commit('changeLogIn', false)
    }

  })

}

init()
